// extracted by mini-css-extract-plugin
export default {"addTimeSlot":"PromoCodeForm_addTimeSlot__kt5fR","addTimeSlotButton":"PromoCodeForm_addTimeSlotButton__IPaYq"};